import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const NuevoIncidente = React.lazy(
  () => import("../screean/services/nuevo-incidente")
);
export function nuevoIncidente() {
  return (
    <Route
      path="/nuevo-incidente"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <NuevoIncidente />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
